/**
 * Default shader code templates
 */

// Default shader code (compatible with WebGPU renderer uniforms)
export const DEFAULT_SHADER = `// Slang Shader Example
// Uniforms provided by the renderer
struct Uniforms {
  float2 resolution;
  float time;
  float _padding;
  float2 mouse;
};

[[vk::binding(0, 0)]]
ConstantBuffer<Uniforms> uniforms;

// Texture bindings (click slot buttons in Preview header to load)
[[vk::binding(1, 0)]]
Texture2D<float4> iChannel0;

[[vk::binding(2, 0)]]
SamplerState iSampler;

[[vk::binding(3, 0)]]
Texture2D<float4> iChannel1;

[[vk::binding(4, 0)]]
Texture2D<float4> iChannel2;

[[vk::binding(5, 0)]]
Texture2D<float4> iChannel3;

// Buffer bindings (for multi-pass rendering)
[[vk::binding(6, 0)]]
Texture2D<float4> iBufferA;

[[vk::binding(7, 0)]]
Texture2D<float4> iBufferB;

[[vk::binding(8, 0)]]
Texture2D<float4> iBufferC;

[[vk::binding(9, 0)]]
Texture2D<float4> iBufferD;

struct VertexOutput {
  float4 position : SV_Position;
  float2 uv : TEXCOORD0;
};

[shader("fragment")]
float4 fragMain(VertexOutput input) : SV_Target {
  float2 uv = input.uv;

  // Animated gradient
  float3 color = float3(
    uv.x,
    uv.y,
    0.5 + 0.5 * sin(uniforms.time)
  );

  return float4(color, 1.0);

  // ---- Noise texture example ----
  // Load "Noise" preset from texture slot, then uncomment below:
  //
  // float noise = iChannel0.Sample(iSampler, uv * 4.0).r;
  // float3 color = float3(noise);
  // return float4(color, 1.0);

  // ---- Buffer A example (multi-pass) ----
  // In Buffer A tab, write to iBufferA. Then read it here:
  // float4 bufferColor = iBufferA.Sample(iSampler, uv);
  // return bufferColor;
}
`;

// Default buffer shader template
export const DEFAULT_BUFFER_SHADER = `// Buffer Pass
// Output is written to this buffer and can be read as iBufferX in other passes
struct Uniforms {
  float2 resolution;
  float time;
  float _padding;
  float2 mouse;
};

[[vk::binding(0, 0)]]
ConstantBuffer<Uniforms> uniforms;

[[vk::binding(1, 0)]]
Texture2D<float4> iChannel0;

[[vk::binding(2, 0)]]
SamplerState iSampler;

[[vk::binding(3, 0)]]
Texture2D<float4> iChannel1;

[[vk::binding(4, 0)]]
Texture2D<float4> iChannel2;

[[vk::binding(5, 0)]]
Texture2D<float4> iChannel3;

// Buffer bindings - read previous frame's output
[[vk::binding(6, 0)]]
Texture2D<float4> iBufferA;

[[vk::binding(7, 0)]]
Texture2D<float4> iBufferB;

[[vk::binding(8, 0)]]
Texture2D<float4> iBufferC;

[[vk::binding(9, 0)]]
Texture2D<float4> iBufferD;

struct VertexOutput {
  float4 position : SV_Position;
  float2 uv : TEXCOORD0;
};

[shader("fragment")]
float4 fragMain(VertexOutput input) : SV_Target {
  float2 uv = input.uv;

  // Example: read previous frame and add slight change
  // float4 prev = iBufferA.Sample(iSampler, uv);
  // return prev * 0.99 + float4(uv, 0.5 + 0.5 * sin(uniforms.time), 1.0) * 0.01;

  return float4(uv, 0.5 + 0.5 * sin(uniforms.time), 1.0);
}
`;
